import router from '../../router'

export interface Stamp {
  amount: number
  token: {
    name: string
    description: string
  }
  expiration_time: string
  release_time: string
}

export interface State {
  stamps: Stamp[]
  isStampsLoading: boolean
  capturedStamp: null | Stamp
  isStampCapturing: boolean
  selected: {
    name: string
    amount: number
  }
  isCaptureLoading: boolean
  currentLocation: {
    latitude: number
    longitude: number
  }
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  stamps: [],
  isStampsLoading: false,
  capturedStamp: null,
  isStampCapturing: false,
  selected: {
    name: '',
    amount: 0
  },
  isCaptureLoading: false,
  currentLocation: {
    latitude: 0,
    longitude: 0
  }
}

export const mutations: Mutations = {
  setStamps(state, payload) {
    state.stamps = payload.stamps
  },
  onStampsLoadingStart(state) {
    state.isStampsLoading = true
  },
  onStampsLoadingFinished(state) {
    state.isStampsLoading = false
  },
  setCapturedStamp(state, payload) {
    state.capturedStamp = payload
  },
  onStampCapturingStart(state) {
    state.isStampCapturing = true
  },
  onStampCapturingFinished(state) {
    state.isStampCapturing = false
  },
  setSelecrStamp(state, payload) {
    state.selected = {
      name: payload.journal.from.name,
      amount: payload.journal.amount
    }
  },
  onCaptureLoadingStart(state) {
    state.isCaptureLoading = true
  },
  onCaptureLoadingFinished(state) {
    state.isStampsLoading = false
  },
  setCurrentLocation(state, payload) {
    state.currentLocation = payload
  }
}

export const actions: Actions = {
  async fetchCheckInStamps({ commit }, payload) {
    commit('setCurrentLocation', payload)
    commit('onStampsLoadingStart', {})
    const { response, error } = await this.$api.fetchCheckInStamps(payload)
    if (response) {
      commit('setStamps', response)
      await this.$delay(500)
      commit('onStampsLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onStampsLoadingFinished', {})
  },
  async postCaptureStamp({ commit }, payload) {
    new Promise(async (resolve, reject) => {
      commit('onStampCapturingStart', {})
      const { response, error } = await this.$api.fetchStamp(payload)
      if (response) {
        resolve(response.stamp)
        return
      }
      reject(error)
    })
      .then(async stamp => {
        const { response, error } = await this.$api.postCaptureStamp(payload)
        if (response) {
          commit('setCapturedStamp', stamp)
        }
      })
      .finally(async () => {
        await this.$delay(500)
        commit('onStampCapturingFinished', {})
      })
  },
  async postCheckIn({ commit }, payload) {
    commit('onCaptureLoadingStart', {})
    const { response } = await this.$api.postCheckIn(payload)
    if (response) {
      commit('setSelecrStamp', response)
      await this.$delay(500)
      commit('onCaptureLoadingFinished', {})
      router.push('/checkin/complete')
      return
    }
    await this.$delay(500)
    commit('onCaptureLoadingFinished', {})
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
